import { Theme, styled } from '@quillbot/design-system';

export default styled('button')`
  background: none;
  color: ${({ theme }: { theme: Theme }) => theme.specialColors.BLUE_COLOR};
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  outline: inherit;
  margin: 0;
`;
